var map = {
	"./chapter-1.png": "4444",
	"./chapter-2.png": "2166",
	"./chapter-3.png": "48a6",
	"./chapter-4.png": "f865",
	"./chapter-5.png": "4aab",
	"./chapter-6.png": "2ce3",
	"./chicken_eggs.png": "cbbe",
	"./close-chapters.png": "948c",
	"./colonial_uprising.png": "a32f",
	"./diamond_soldier.png": "2608",
	"./dubai.png": "1086",
	"./enablers.png": "a9bf",
	"./enter-isabel.png": "9b0e",
	"./enter_china.png": "ffa4",
	"./filomeno-fired.png": "90cc",
	"./filomeno.png": "c9ba",
	"./forbes.png": "7879",
	"./icij-black.svg": "3ed0",
	"./icon-chapters.png": "3451",
	"./ids-fired.png": "93dc",
	"./ids-sonangol.png": "6dac",
	"./ids_marriage.png": "af51",
	"./independency_flag.png": "1336",
	"./independency_neto.png": "2485",
	"./independency_people.png": "425d",
	"./isabel_village1.png": "d94c",
	"./jose-exile.png": "3800",
	"./jose_dosantos_assume_power.png": "f726",
	"./logo copy.png": "d90a",
	"./logo.png": "cf05",
	"./logo_black.png": "36b4",
	"./map-colony.png": "bc4a",
	"./new-president.png": "3dad",
	"./new_elections.png": "b8b6",
	"./newsletter_icon.png": "8d6b",
	"./oil-chart-2.png": "9f25",
	"./oil-chart.png": "9922",
	"./santos-negotiation.png": "5d2e",
	"./signature.png": "d6f5",
	"./slide_3.png": "415a",
	"./slide_4.png": "9a93",
	"./sonangol_header.png": "e5b4",
	"./tchize-dos-santos.png": "dca8",
	"./unitel_header.png": "7012",
	"./village2.png": "376b",
	"./war_ends.png": "0308",
	"./worst_war.png": "9eeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";